export const environment = {
  production: true,
  agGridLicenseKey: '',
  iframeTargetOrigin: '*', // Make sure to specify an actual origin for prod builds.
  iframePath: '/irebal/accounts/inventory',
  walkMeEnabled: true,
  walkMeSource: 'https://cdn.walkme.com/users/0d9e6c9d857f459f9cf94db369a5bfff/test/walkme_0d9e6c9d857f459f9cf94db369a5bfff_https.js',
  walkMeSourceProd: 'https://cdn.walkme.com/users/0d9e6c9d857f459f9cf94db369a5bfff/walkme_0d9e6c9d857f459f9cf94db369a5bfff_https.js'
};
